import styled from "styled-components";

import twitter from "../assets/socials/twitter.svg";
import discord from "../assets/socials/discord.svg";
import medium from "../assets/socials/medium.svg";
import etherscan from "../assets/socials/etherscan.svg";
import opensea from "../assets/socials/opensea.svg";
import instagram from "../assets/socials/instagram.svg";
import { OPENSEA_LINK } from "../app/globals";

interface SocialType {
  image: string;
  link: string;
  name: string;
}

const socials: SocialType[] = [
  {
    image: opensea,
    link: OPENSEA_LINK,
    name: "Killer GF on OpenSea",
  },
  {
    image: discord,
    link: "https://discord.gg/cKWpT7HGam",
    name: "Killer GF on Discord",
  },
  {
    image: twitter,
    link: "https://twitter.com/killergfnft",
    name: "Killer GF on Twitter",
  },
  {
    image: instagram,
    link: "https://www.instagram.com/killergfnft/",
    name: "Killer GF on Instagram",
  },
  {
    image: etherscan,
    link: "https://etherscan.io/address/0x6bE69b2A9B153737887CfcdCa7781eD1511C7e36#code",
    name: "Killer GF contract on Etherscan",
  },
  {
    image: medium,
    link: "https://killergf.medium.com",
    name: "Killer GF on Medium",
  },
];

const StyledSocials = styled.div<{ $compact?: boolean }>`
  display: flex;
  align-items: center;
  margin-top: ${(props) => (props.$compact ? "0" : "1.5rem")};
`;

const SocialLink = styled.a<{ $compact?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: ${(props) => (props.$compact ? "0 0.45rem" : "0 0.8rem")};
  transition: transform 0.22s ease, opacity 0.22s ease;

  &:hover {
    transform: translateY(-2px) scale(${(props) => (props.$compact ? 1.05 : 1.06)});
  }

  &:active {
    transform: translateY(0) scale(0.98);
  }
`;

const SocialImage = styled.img<{ $compact?: boolean }>`
  height: ${(props) => (props.$compact ? "2.2rem" : "3.3rem")};
  width: ${(props) => (props.$compact ? "2.2rem" : "3.3rem")};
  opacity: 0.92;
  transition: transform 0.22s ease, opacity 0.22s ease, filter 0.22s ease;

  ${SocialLink}:hover & {
    opacity: 1;
    filter: drop-shadow(0 0 8px rgba(255, 0, 102, 0.28));
  }
`;

const FollowUs = styled.p`
  font-weight: 400;
  font-size: 1.8rem;
  color: var(--main);
  padding-bottom: 1.4rem;
  text-transform: uppercase;
`;

interface Props {
  showHeader?: boolean;
  compact?: boolean;
}

const Socials = ({ showHeader, compact }: Props) => {
  return (
    <>
      {showHeader && <FollowUs>follow us</FollowUs>}
      <StyledSocials $compact={compact}>
        {socials.map((social: SocialType) => (
          <SocialLink
            $compact={compact}
            key={social.name}
            href={social.link}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={social.name}
          >
            <SocialImage $compact={compact} src={social.image} alt="" />
          </SocialLink>
        ))}
      </StyledSocials>
    </>
  );
};

export default Socials;
